<fmnts-compliment
  [label]="this.label"
  [image]="this.image"
  [labelPosition]="this.labelPosition"
  [state]="this.checked ? 'default' : 'disabled'"
  [size]="this.checked ? 'lg' : 'md'"
></fmnts-compliment>
